import moment from 'moment'
import { useDateStore } from '@/modules/drivers/stores/dateStore'
import type { DatePickerProps } from '@/modules/drivers/types'

const API_DATE_FORMAT = 'YYYY-MM-DD'

const toApiDate = (date: DatePickerProps | null): string | null => {
  if (!date || date.year == null || date.month == null || date.day == null) {
    return null
  }

  return moment({
    year: date.year,
    month: date.month - 1,
    day: date.day,
  }).format(API_DATE_FORMAT)
}


export const useGlobalDateRange = (): { from: string; to: string } => {
  const range = useDateStore((s) => s.range)

  return {
    from: toApiDate(range?.startDate ?? null) ??
      moment().subtract(1, 'month').format(API_DATE_FORMAT),
    to: toApiDate(range?.endDate ?? null) ?? moment().format(API_DATE_FORMAT),
  }
}
